/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyMethodModel } from '../../models/client-survey-method-model';

export interface GetSurveyMethods$Plain$Params {
}

export function getSurveyMethods$Plain(http: HttpClient, rootUrl: string, params?: GetSurveyMethods$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyMethodModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveyMethods$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSurveyMethodModel>>;
    })
  );
}

getSurveyMethods$Plain.PATH = '/api/SurveyMethod';
